import React, { Component } from "react";
import { Accessor, ColorX, GFunc, LocaleX, ZValidate } from "IZOX/STATIC";
import { HStack, VStack, XButton, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { observer } from "mobx-react";
import { QForm } from "IZOX/BLOCKS/Libs";
import Styles from "__SYSDefault/Styles";
import { QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import _ from "lodash";
import APIExpress from "__SYSDefault/APIs/APIExpress";

/**
 * @augments {Component<Props, State>}
 */
class EmailForm extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(EmailForm.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _onFormChange = (formValue) => {
    this.setState({
      formValue: formValue
    });
  }

  _onSubmit = async () => {
    let {formValue} = this.state;

    if(!ZValidate.Check(formValue?.email, ["email"])){
      GFunc.Alert({
        EN: "Please enter valid email.",
        TC: "請輸入有效電郵地址"
      }, "error");
      return;
    }

    if(!ZValidate.CheckAllFields(formValue, ["name", "email"], "required")){
      GFunc.Alert({
        EN: "Please fill in necessary fields.",
        TC: "請填寫必填欄位。"
      }, "error");
      return;
    }

    let res = await APIExpress.PublicMessages.SubmitForm(formValue);
    if(res.Success){
      this.MountQForm.Clear({zip: "+852"});
      GFunc.Alert({
        EN: "Successfully Submitted",
        TC: "成功上傳"
      }, "success");
    }else{
      GFunc.Alert({
        EN: "Network problem. Please try again later.",
        TC: "網絡不穩定，請稍後再試。"
      }, "warn");
    }
  }

  onMountQForm = (callbacks) => {
    this.MountQForm = callbacks;
  }

  renderField(label, placeholder, name, required){
    return (
      <VStack fullWidth>
        <HStack HAlign="[" spacing={5}>
          <XText fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
          {required && 
            <XText color={ColorX.CSS("Blood")} fontSize={12}>
              {"*"}
            </XText>}
        </HStack>
        <QFText 
          {...Styles.QFText}
          placeholder={LocaleX.Parse(placeholder)}
          name={name}/>
      </VStack>
    );
  }

  render(){
    let {formValue} = this.state;
    let name = Accessor.Get(formValue, "name");
    let email = Accessor.Get(formValue, "email");
    let isFormValid = !_.isEmpty(name)
      && ZValidate.Check(email, ["required", "email"]);
    return (
      <VStack width={"50%"} HAlign="[" spacing={24} pB={127}>
        <HStack>
          <XText fullWidth textAlign="[" color={ColorX.CSS("Stone")} bold fontSize={16}>
            {LocaleX.Parse({
              EN: "Send a message",
              TC: "傳送信息"
            })}
          </XText>
        </HStack>
        <QForm onMounted={this.onMountQForm} onChange={this._onFormChange} 
          fullWidth spacing={24}>
          {this.renderField({
              EN: "Name",
              TC: "姓名"
            }, {
              EN: "Enter your name",
              TC: "輸入你的姓名"
            }, "name", true)}
          {this.renderField({
              EN: "Email address",
              TC: "電郵地址"
            }, {
              EN: "Enter your email",
              TC: "輸入你的電郵"
            }, "email", true)}
        <HStack fullWidth spacing={13}>
          <QFText 
            {...Styles.QFText}
            name="zip"
            textAlign="|"
            width={104}
            defaultValue={"+852"} readOnly/>
          <QFText fontSize={14} p={12}
            {...Styles.QFText}
            name="mobile"
            width={104}
            placeholder={LocaleX.Parse({
              EN: "Enter your mobile phone no.",
              TC: "輸入你的電話號碼"
            })}
            numberOnly
            fullWidth/>
          </HStack>
          <VStack fullWidth>
            <HStack HAlign="[" spacing={5}>
              <XText fontSize={12}>
                {LocaleX.Parse({
                  EN: "Leave message",
                  TC: "留言"
                })}
              </XText>
            </HStack>
              <QFText 
                {...Styles.QFText}
                name="message"
                placeholder={LocaleX.Parse({
                  EN: "Leave a message for us...",
                  TC: "給我們一個留言"
                })}
                height={100}
                numberOfLines={4}/>
          </VStack>
          <HStack fullHeight>
            <XButton fullWidth
              {...Styles.QFBtn}
              disabled={!isFormValid}
              onPress={this._onSubmit}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Submit",
                    TC: "提交"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </QForm>
      </VStack>
    );
  }

}

export default observer(EmailForm);
